export default __webpack_public_path__ + "6ff9f669a85c0d616528f07835d443c3.png";